import { DepthOfField, EffectComposer, Vignette, Bloom, Noise } from "@react-three/postprocessing"
import Orchestreur from "../../Orchestreur"
import EnvMap from "../../props/EnvMap"
import Camera from "./props/camera"
import Light from "./props/lights"
import ActeThreeModels from "./models/ActeThreeModels"
import { useControls } from "leva"
import { useEffect, useRef } from "react"

export default function ActeThree({ progress }) {

    return (
        <>
            <Orchestreur
                id={2}
                progress={progress}
                range={{ start: 0.6, end: 0.95 }}
                Env={EnvMap}
                Lights={Light}
                Models={ActeThreeModels}
                Camera={Camera}
                fog={{ color: '#c7e9ff', near: 11.5, far: 20}}
                
            />
        </>
    )
}